<template>
    <div>
        <div class="ph-position-bar">
            <div class="ph-position-bar-left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item class="breadcrumb-item" :class="itemClass" v-for="(nav,index) in positionNav" :key="index" :to="nav.path" >{{ nav.title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import { session } from "../storage/storage.js";

    export default {
        name: "ph-position-bar",
        props:{
            positionNav:{
                type:Array,
                default: () => []
            }
        },
        data(){
            return {
                itemClass:''
            }
        },
        mounted(){
            this.itemClass=session.get('channel_id')==1?'woodpecker':session.get('channel_id')==2?'dte':'dba'

        },
        methods:{

        }
    }
</script>

<style>
    .ph-position-bar{
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: .3rem 0 .3rem .3rem;
    }
    .ph-position-bar-left{
        font-size: 28px;
        color: #5d5f5f;
    }


    .ph-position-bar .el-breadcrumb__inner.is-link {
        color: #606266;
    }

    .ph-position-bar .el-breadcrumb__inner {
        font-size: .24rem;
        margin: .2rem 0;
    }
    .breadcrumb-item {
        line-height: 1.6;
    }

    .woodpecker .is-link:hover{
        color: #e62129;
    }
    .dte .is-link:hover{
        color: #1a4698;
    }
    .dba .is-link:hover{
        color: #000000;
    }
</style>